// Vendor libraries - loaded in correct order
// NOTE: typeahead.js is NOT bundled here because its UMD factory requires jQuery as a global
// at evaluation time. It's loaded via script tag in base.jinja2 instead.

// 1. jQuery first - set up globals
import realJQuery from 'jquery';
window.$ = window.jQuery = realJQuery;

// Polyfill deprecated jQuery methods used by typeahead.js 0.11.1
if (realJQuery && typeof realJQuery.isArray !== 'function') {
  realJQuery.isArray = Array.isArray;
}
if (realJQuery && typeof realJQuery.isFunction !== 'function') {
  realJQuery.isFunction = function(obj) {
    return typeof obj === 'function';
  };
}

// 2. Lodash/Underscore
import _ from 'underscore';
import lodash from 'lodash';
window._ = _;
window.lodash = lodash;

// 3. jQuery UI
import 'jquery-ui/dist/jquery-ui.js';

// 4. Backbone
import Backbone from 'backbone';
window.Backbone = Backbone;

// 5. Bootstrap
import 'bootstrap';

// 6. Typeahead/Bloodhound - loaded via script tag AFTER this bundle
// See base.jinja2 fallback loader or the inline script that loads it

// 7. GridStack
import { GridStack } from 'gridstack';
window.GridStack = GridStack;

// 8. Plotly is loaded as the full same-origin distribution in base.jinja2.
// Keeping it out of this bundle avoids a race where the basic distribution
// overwrites the full renderer while a specialized chart is initializing.

// 9. Shepherd
import Shepherd from 'shepherd.js';
window.Shepherd = Shepherd;

// 10. D3
if (typeof d3 === 'undefined' && window.d3) {
  window.d3 = window.d3;
}

// 11. Material Design Lite (provides window.componentHandler + auto-upgrades mdl-* elements)
import '../src/js/material.min.js';

console.log('Vendor libraries loaded');
